function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect } from "react";
import { MBAThemeProvider, primaryTheme } from "@muchbetteradventures/styleguide";
import { AuthProvider, getOrCreateAuthAPISingleton } from "@muchbetteradventures/signup-form-lib";
import MenuBar from "./components/MenuBar";
import trackEvent from "./tracking";
import { liveChatInit } from "./liveChat";
var auth = getOrCreateAuthAPISingleton();
export default (function (props) {
  var knowledgeBaseUrl = props.knowledgeBaseUrl,
      _theme = props.theme;
  var theme = _theme || primaryTheme;
  var liveChatZIndex = theme.zIndex.menuBar + 1;
  useEffect(function () {
    liveChatInit(knowledgeBaseUrl, liveChatZIndex);
  }, []);
  return /*#__PURE__*/React.createElement(AuthProvider, {
    auth: auth
  }, /*#__PURE__*/React.createElement(MBAThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(MenuBar, _extends({}, props, {
    trackEvent: trackEvent
  }))));
});